import axios from 'axios';
import { toast } from 'react-toastify';
import { readLanguage } from 'src/components/common/header/helper';

const create = (baseUrl) => {
  const nzAxios = axios.create({
    baseURL: baseUrl,
    headers: {
      post: {
        'Content-Type': 'application/json; charset=UTF-8'
      },
      patch: {
        'Content-Type': 'application/json; charset=UTF-8'
      },
      put: {
        'Content-Type': 'application/json; charset=UTF-8'
      },
      common: {
        'X-NZ-API-VERSION': '1.0'
      }
    }
  });

  nzAxios.clearBaseURL = () => (nzAxios.defaults.baseURL = '');

  nzAxios.interceptors.request.use((request) => {
    const language = readLanguage();

    if (language?.language) {
      request.headers.set('User-Language', language.language);
    }

    return request;
  });

  nzAxios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (!error.response) {
        toast.error('Сталась помилка зʼєднання. Спробуйте ще раз.');
      } else {
        toast.error(error);
        return Promise.reject(error);
      }
    }
  );

  return nzAxios;
};

const nzApiAxios = create(process.env?.REACT_APP_API_BASE_URL);

export { nzApiAxios };
